import { mergeProductPricesToProductLister } from '@as-react/common-utils';
import { all, put, select, take, takeEvery, call, getContext } from 'redux-saga/effects';
import { CookieConsentActionTypes, MonetateActionTypes, GeneralActionTypes } from '../../../enums/ActionEnums';
import { makeGetHasConsentOnMarketingCookies } from '../../cookieConsent/selectors/CookieConsentSelector';
import { monetateActions } from '../actions/MonetateActions.creators';
import { monetateStateSelector, makeGetMonetateRecommendations } from '../selectors/MonetateSelectors';
import MonetateUtil from '../../../util/MonetateUtil';
import { EventEnum } from '@as-react/common-types';
import { ScriptLoadingState } from '../../../enums/GeneralEnums';
import ProductsAPI from '../../../api/ProductsAPI';
import ProductDetailAPI from '../../../api/ProductDetailAPI';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import { COOKIE_CONSENT_ACCEPTED } from '../../../constants/StorageKeysConstants';
function* customEventSaga() {
    yield takeEvery(GeneralActionTypes.CUSTOM_EVENT, handleCustomEvent);
}
function* handleCustomEvent(action) {
    switch (action.payload.eventType) {
        case EventEnum.MONETATE_SCRIPT_LOADED:
            yield put(monetateActions.loaded());
            break;
        default:
            break;
    }
}
function* initMonetateSaga() {
    yield take(MonetateActionTypes.INIT);
    yield call(initMonetate);
}
function* loadMonetateSaga() {
    yield take(MonetateActionTypes.LOAD);
    yield call(loadMonetate);
}
function* onCookieConsentChangeSaga() {
    yield take(CookieConsentActionTypes.SET);
    yield call(checkForMonetateLoad);
}
function* initMonetate() {
    const consentMarketing = yield select(makeGetHasConsentOnMarketingCookies());
    const isCookieConsentAccepted = LocalStorageUtil.getItem(COOKIE_CONSENT_ACCEPTED);
    if (isCookieConsentAccepted || consentMarketing) {
        yield put(monetateActions.load());
    }
    else {
        yield put(monetateActions.onHold());
    }
}
function* loadMonetate() {
    const { monetateUrl } = yield getContext('aemConfiguration');
    if (monetateUrl) {
        yield call(MonetateUtil.init, monetateUrl);
    }
}
function* checkForMonetateLoad() {
    const consentMarketing = yield select(makeGetHasConsentOnMarketingCookies());
    const monetateState = yield select(monetateStateSelector);
    if (consentMarketing && monetateState.scriptState === ScriptLoadingState.ON_HOLD) {
        yield put(monetateActions.load());
    }
}
function* fetchProductsSaga() {
    yield takeEvery(MonetateActionTypes.FETCH_PRODUCTS, fetchProducts);
}
export function* fetchMonetateProducts({ actionId, size, filterProductId }) {
    const recommendations = yield select(makeGetMonetateRecommendations(actionId));
    const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
    const products = yield all(recommendations
        .filter(({ productcode }) => productcode)
        .map(({ productcode, idColour }) => call(ProductsAPI.getProductInformationAPI, servicesEndpoint, defaultRequestParams, productcode, idColour ? Number(idColour) : undefined)));
    const availableProducts = products.filter(product => product && product.productCode && product.availability > 0);
    const filteredIdProducts = filterProductId
        ? availableProducts.filter(product => product.productId !== Number(filterProductId))
        : availableProducts;
    const filteredProducts = size ? filteredIdProducts.slice(0, size) : filteredIdProducts;
    const productsWithAvailableColors = filteredProducts.map(product => {
        const availableColors = product.colours.filter(color => color.availability > 0);
        const isDefaultColorAvailable = availableColors.find(color => color.colourId === product.colourId);
        return Object.assign(Object.assign({}, product), { colourId: isDefaultColorAvailable ? product.colourId : availableColors[0].colourId, colours: availableColors });
    });
    const productsPrices = yield ProductDetailAPI.getAllProductDetailPriceByProductId(productsWithAvailableColors.map(product => product.productId), servicesEndpoint, defaultRequestParams);
    const productsWithPrices = productsWithAvailableColors.map(product => {
        const productPrice = productsPrices.find(price => product.productId === price.productId);
        return mergeProductPricesToProductLister(product, productPrice);
    });
    return productsWithPrices;
}
function* fetchProducts({ payload }) {
    try {
        const products = yield call(fetchMonetateProducts, payload);
        yield put(monetateActions.setMonetateProducts({ [payload.actionId]: products }));
    }
    catch (_a) { }
}
export default function* monetateSaga() {
    yield all([
        initMonetateSaga(),
        onCookieConsentChangeSaga(),
        loadMonetateSaga(),
        customEventSaga(),
        fetchProductsSaga(),
    ]);
}
